/* eslint-disable indent */
import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';

export const ColStyled = styled(Col)`
  ${({ theme }) => {
    const xlargeUp = theme.xlargeUp();
    const mediumUp = theme.mediumUp();
    let thisHorizontalPadding = rem(15);

    if(xlargeUp){
      thisHorizontalPadding = rem(25);
    }

    return css`
      display: flex;
      overflow: hidden;
      ${mediumUp && (`
        padding-left: ${thisHorizontalPadding};
        padding-right: ${thisHorizontalPadding};
      `)}
    `;
  }}
`;

export const RowStyled = styled(Row)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      padding-top: ${mediumUp ? rem(60) : rem(48)};
    `;
  }}
`;

export const SectionContainerStyled = styled(SectionContainer)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      &&& {
        ${!mediumUp && `padding-bottom: ${rem(32)};`}
      `;
      }
    }
  }
`;
